import React, { FC } from "react";
import InputMask from "react-input-mask";
import { FormControl, FormGroup } from "react-bootstrap";
import LLabel from "components/Inputs/LLabel";
import "../styles.css";

interface LInputMaskProps {
  label?: string;
  name: string;
  className?: string;
  classNameInput?: string;
  styleGroup?: React.CSSProperties;
  styleInput?: React.CSSProperties;
  mask?: string;
  placeholder?: string;
  id?: string;
  type?: string;
  disabled?: boolean;
  value?: string;
  required?: boolean;
  isInvalid?: boolean;
  size?: "sm" | "md" | "lg";
  error?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: any) => void;
}

const LFieldMask2: FC<LInputMaskProps> = ({
  label,
  name,
  mask,
  className,
  classNameInput,
  styleGroup,
  styleInput,
  placeholder,
  id,
  isInvalid,
  value,
  error,
  type = "text",
  size = "md",
  required = false,
  disabled = false,
  onChange,
  onBlur,
  ...props
}) => {

  return (
    <FormGroup className={`form-group ${className}`} style={styleGroup}>
      <div>
        {label && <LLabel label={label} required={required} />}

        <FormControl
          id={id}
          name={name}
          as={InputMask}
          mask={mask || ""}
          placeholder={placeholder}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          value={value || ""}
          isInvalid={isInvalid}
          className={`form-control form-control-${size} ${classNameInput}`}
          style={styleInput}
          {...props}
          type={type}
        />
        {isInvalid ? (
          <div className="d-flex justify-content-start text-red-500 text-xs">{error}</div>
        ) : null}
      </div>
    </FormGroup>
  );
};

export default LFieldMask2;
